/**
 * VEXIA — Moteur d'animations (GSAP + ScrollTrigger)
 *
 * Chargé après gsap.min.js et gsap-scrolltrigger.min.js.
 * Toutes les animations sont désactivées si l'utilisateur a demandé
 * « réduire les animations » (prefers-reduced-motion) : le contenu reste
 * alors parfaitement visible et statique.
 *
 * Filet de sécurité : le contenu ne peut jamais rester masqué de façon
 * permanente. Si GSAP/ScrollTrigger manque, si une erreur survient, si la
 * page est imprimée, ou si le visiteur ne défile pas (robot d'indexation,
 * aperçu, capture), tous les éléments animés sont révélés.
 *
 * Usage déclaratif (aucune JS à écrire pour animer un élément) :
 *   data-animate="fade-up"        → apparition en fondu + montée au scroll
 *   data-animate="fade"           → simple fondu
 *   data-animate="fade-left/right"→ fondu + glissement latéral
 *   data-animate-stagger          → anime les enfants directs en cascade
 *   data-animate-delay="0.2"      → délai (secondes)
 */
(function () {
  'use strict';

  var SELECTOR = '[data-animate], [data-animate-stagger]';

  // Révèle sans condition tout élément animé (et les enfants des staggers).
  // Sûr à appeler plusieurs fois. N'utilise pas GSAP pour rester fonctionnel
  // même si la librairie n'a pas chargé.
  function revealAll() {
    var nodes = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      el.style.visibility = 'visible';
      el.style.opacity = '1';
      el.style.transform = 'none';
      if (el.hasAttribute('data-animate-stagger')) {
        for (var j = 0; j < el.children.length; j++) {
          var child = el.children[j];
          child.style.visibility = 'visible';
          child.style.opacity = '1';
          child.style.transform = 'none';
        }
      }
    }
  }

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Pas d'animation possible ou souhaitée → on garantit le contenu visible.
  if (reduce || typeof gsap === 'undefined') {
    revealAll();
    return;
  }

  // GSAP présent mais ScrollTrigger absent : on révèle simplement (sans scroll).
  if (typeof ScrollTrigger === 'undefined' && !(window.gsap && window.ScrollTrigger)) {
    revealAll();
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  var PRESETS = {
    'fade': { from: { autoAlpha: 0 } },
    'fade-up': { from: { autoAlpha: 0, y: 32 } },
    'fade-left': { from: { autoAlpha: 0, x: -32 } },
    'fade-right': { from: { autoAlpha: 0, x: 32 } }
  };

  function reveal(el) {
    var name = el.getAttribute('data-animate') || 'fade-up';
    var preset = PRESETS[name] || PRESETS['fade-up'];
    var delay = parseFloat(el.getAttribute('data-animate-delay')) || 0;

    gsap.from(el, {
      duration: 0.9,
      ease: 'power3.out',
      delay: delay,
      autoAlpha: preset.from.autoAlpha,
      x: preset.from.x || 0,
      y: preset.from.y || 0,
      scrollTrigger: { trigger: el, start: 'top 88%', once: true }
    });
  }

  function revealStagger(container) {
    var children = container.children;
    var name = container.getAttribute('data-animate') || 'fade-up';
    var preset = PRESETS[name] || PRESETS['fade-up'];

    gsap.from(children, {
      duration: 0.8,
      ease: 'power3.out',
      autoAlpha: preset.from.autoAlpha,
      x: preset.from.x || 0,
      y: preset.from.y || 0,
      stagger: 0.09,
      scrollTrigger: { trigger: container, start: 'top 85%', once: true }
    });
  }

  function init() {
    try {
      document.querySelectorAll('[data-animate-stagger]').forEach(revealStagger);
      document.querySelectorAll('[data-animate]:not([data-animate-stagger])').forEach(reveal);
      ScrollTrigger.refresh();
    } catch (err) {
      // En cas d'échec de l'anim, ne jamais laisser le contenu caché.
      if (window.console) console.warn('[VEXIA] animations désactivées :', err);
      revealAll();
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  // Recalcule les déclencheurs après chargement complet (images, polices).
  window.addEventListener('load', function () {
    if (window.ScrollTrigger) ScrollTrigger.refresh();
  });

  // ---- Filets de sécurité anti-contenu-fantôme ----

  // 1) Le visiteur ne défile pas (robot, aperçu, lecture du seul hero) :
  //    après un court délai, on révèle tout le contenu resté masqué afin
  //    qu'il soit présent et visible dans le DOM. Si le visiteur défile,
  //    les animations au scroll jouent normalement à la place.
  var scrolled = false;
  window.addEventListener('scroll', function () { scrolled = true; }, { once: true, passive: true });
  window.addEventListener('load', function () {
    setTimeout(function () { if (!scrolled) revealAll(); }, 2500);
  });

  // 2) Impression : tout doit être visible sur le papier.
  window.addEventListener('beforeprint', revealAll);
})();
